import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import Title from "../Title";
import { UploadIcon, ResetIcon } from "../../../Assets/images/svgs"; 
import { Button } from '@chakra-ui/react';

const UploadImageModal = ({ existingProfileImage, show = true, submit = "Submit", onCancel, onSubmit, showUploading = true }) => {
  const [ profileImage, setProfileImage ] = useState(existingProfileImage || {});
  const [ isFileDragged, setIsFileDragged ] = useState(false);

  const fileInputRef = useRef();

  const handleFileDragAndDrop = (event, drag) => {
    event.preventDefault();
    if (drag && !isFileDragged) {
      setIsFileDragged(true);
    }

    const file = event.dataTransfer?.files[0];
    if (file && file.type.startsWith("image/")) {
      setProfileImage(file);
      setIsFileDragged(false);
    }
  }

  const cancelUpload = () => {
    setProfileImage({ });
    onCancel();
  }

  useEffect(() => {
    if (!show) {
      setProfileImage({ });
    }
  }, [ show ])

  const handleFileUpload = (event) => {
    if (!event.target.files.length) {
      return;
    }

    setProfileImage(event.target.files[0])
  }

  return (
    <>
      { show ? <div className="upload-image-modal">
        <div className="image-modal-overlay">
          <div className="image-modal-container">
            <Title children={"Add Profile Photo"} />

            <div className="upload-section">
              <div onClick={() => fileInputRef.current?.click()} className={`drag-and-drop-box ${profileImage.name ? "remove-padding" : ""} ${isFileDragged ? "drag-overlay" : ""}`} onDragOver={(e) => handleFileDragAndDrop(e, true)} onDragLeave={() => setIsFileDragged(false)} onDrop={(e) => handleFileDragAndDrop(e)} >
                {!profileImage.name ?
                <>
                  <UploadIcon className="upload-icon" />
                  <p>Drag & drop your <br /> image here</p>
                </> :
                <div className="uploaded-image-container">
                  <img className="uploaded-image" src={URL.createObjectURL(profileImage)} alt="" />
                  {showUploading ?
                    <>
                      <div className="uploaded-image-overlay"></div>
                      <div className="upload-image-loader"></div>
                    </>
                  : null}
                </div>}
              </div>

              <div className={`uploader-cover ${profileImage.name ? "hide" :""}`}>
                <p className="upload-options-text">or</p>
                <label className="image-modal-upload-button" ref={fileInputRef}>
                  Upload a photo
                  <input type="file" accept="image/*" onChange={handleFileUpload} />
                </label>
              </div>

              { profileImage.name ?  <Button onClick={() => fileInputRef.current.click()} className="remove-profile-image" leftIcon={<ResetIcon />}> Change Photo </Button> : null}
            </div>

            <div className="upload-modal-buttons">
              <Button className="upload-modal-cancel-button" onClick={cancelUpload}> Cancel </Button>
              <Button className={`upload-modal-submit-button ${profileImage.name ? "" : "disabled-btn"}`} disabled={Boolean(profileImage.name)} onClick={() => onSubmit(profileImage)}> { submit } </Button>
            </div>
          </div>
        </div>
      </div> : null }
    </>
  )
}

export default UploadImageModal